export default __webpack_public_path__ + "static/media/notifications-header.5b9795aa.svg";